import { render } from "./PrintInvoiceContactDetailsDesign4.vue?vue&type=template&id=0ab1df25&scoped=true"
import script from "./PrintInvoiceContactDetailsDesign4.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceContactDetailsDesign4.vue?vue&type=script&lang=js"

import "./PrintInvoiceContactDetailsDesign4.vue?vue&type=style&index=0&id=0ab1df25&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab1df25"]])

export default __exports__